<template>
  <div><policies product="DDO"></policies></div>
</template>

<script>
import policies from "./policies.vue";
export default {
  components: { policies },
};
</script>
